"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FontStyleEditor = void 0;
const react_1 = __importStar(require("react"));
const ActionCancelModalComponent_1 = __importDefault(require("@mwater/react-library/lib/ActionCancelModalComponent"));
const layoutOptions_1 = require("./layoutOptions");
const react_select_1 = __importDefault(require("react-select"));
const bootstrap_1 = require("@mwater/react-library/lib/bootstrap");
const ColorComponent_1 = __importDefault(require("../ColorComponent"));
const FontStyleEditor = ({ value, onChange }) => {
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(false);
    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);
    const handleSave = (newValue) => {
        onChange(newValue);
        handleCloseModal();
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', cursor: 'pointer', border: 'solid 1px #DDD', padding: '4px', borderRadius: '6px', justifyContent: 'space-between' }, onClick: handleOpenModal },
            react_1.default.createElement("div", { style: {
                    fontFamily: (0, layoutOptions_1.expandFontFamily)(value.family),
                    fontSize: `${value.size}px`,
                    fontWeight: value.weight,
                    color: value.color
                } }, T `Sample`),
            react_1.default.createElement("div", { style: { fontSize: '10px', color: '#888', marginTop: '2px' } },
                value.family,
                ", ",
                value.size,
                "px")),
        isModalOpen && (react_1.default.createElement(FontEditorModal, { initialValue: value, onSave: handleSave, onCancel: handleCloseModal })));
};
exports.FontStyleEditor = FontStyleEditor;
const FontEditorModal = ({ initialValue, onSave, onCancel }) => {
    const [currentValue, setCurrentValue] = (0, react_1.useState)(initialValue);
    const handleChange = (field, value) => {
        if (field == "family") {
            setCurrentValue(prev => ({ ...prev, [field]: value, weight: "400" }));
        }
        else {
            setCurrentValue(prev => ({ ...prev, [field]: value }));
        }
    };
    // Generate font size options from 5 to 48
    const fontSizeOptions = Array.from({ length: 44 }, (_, i) => i + 5).map(size => ({
        value: size,
        label: `${size}px`
    }));
    // If the font is variable, then the font weight options are much wider
    const fontWeightOptions = [];
    if (currentValue.family === "Roboto") {
        fontWeightOptions.push("100", "300", "400", "500", "700", "900");
    }
    else if (currentValue.family === "Lora") {
        fontWeightOptions.push("400", "500", "600", "700");
    }
    else if (currentValue.family === "Inter") {
        fontWeightOptions.push("100", "200", "300", "400", "500", "600", "700", "800", "900");
    }
    else if (currentValue.family === "Merriweather") {
        fontWeightOptions.push("300", "400", "700", "900");
    }
    else if (currentValue.family === "Lato") {
        fontWeightOptions.push("100", "300", "400", "700", "900");
    }
    else {
        fontWeightOptions.push("400", "700");
    }
    return (react_1.default.createElement(ActionCancelModalComponent_1.default, { title: T `Edit Font`, onAction: () => onSave(currentValue), onCancel: onCancel },
        react_1.default.createElement("div", { style: {
                border: '1px solid #ccc',
                padding: '10px',
                marginBottom: '15px',
                borderRadius: '4px'
            } },
            react_1.default.createElement("div", { style: {
                    marginBottom: '10px',
                    fontSize: '14px',
                    fontWeight: 'bold'
                } }, T `Sample Text:`),
            react_1.default.createElement("div", { style: {
                    fontFamily: (0, layoutOptions_1.expandFontFamily)(currentValue.family),
                    fontSize: `${currentValue.size}px`,
                    fontWeight: currentValue.weight,
                    color: currentValue.color
                } }, T `The quick brown fox jumps over the lazy dog.`)),
        react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Font Family` },
            react_1.default.createElement(react_select_1.default, { value: { value: currentValue.family, label: currentValue.family }, onChange: (option) => handleChange('family', option?.value || ''), options: [
                    { value: 'Helvetica Neue', label: 'Helvetica Neue' },
                    { value: 'Georgia', label: 'Georgia' },
                    { value: 'Inter', label: 'Inter' },
                    { value: 'Lato', label: 'Lato' },
                    { value: 'Lora', label: 'Lora' },
                    { value: 'Lucida Grande', label: 'Lucida Grande' },
                    { value: 'Merriweather', label: 'Merriweather' },
                    { value: 'Roboto', label: 'Roboto' },
                ], formatOptionLabel: (option) => (react_1.default.createElement("span", { style: { fontFamily: (0, layoutOptions_1.expandFontFamily)(option.value) } }, option.label)), isClearable: false, menuPortalTarget: document.body, styles: { menuPortal: (style) => ({ ...style, zIndex: 2000 }) } })),
        react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Font Size:`, horizontal: true },
            react_1.default.createElement(bootstrap_1.Select, { value: currentValue.size, onChange: (value) => handleChange('size', value || 12), options: fontSizeOptions })),
        react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Font Weight:`, horizontal: true },
            react_1.default.createElement(bootstrap_1.Select, { value: currentValue.weight, onChange: (value) => handleChange('weight', value), options: fontWeightOptions.map(weight => ({ value: weight, label: weight })) })),
        react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Font Color:`, horizontal: true },
            react_1.default.createElement(ColorComponent_1.default, { color: currentValue.color, onChange: (value) => handleChange('color', value), disableReset: true }))));
};
